import { FilterType } from '../models/filter';
import { DataStorage } from '@studyportals/data-storage';

import { RouteLocationNormalized } from 'vue-router';

class FilterUsageLogger {
	private storageLabel = 'SearchFilterUsageRecord';

	public logFilters(route: RouteLocationNormalized): void {
		const activeFilters = this.listActiveFilters(route);
		this.storeNewUsageRecord(activeFilters);
		this.announceFilterUpdate();
	}

	private listActiveFilters(route: RouteLocationNormalized): string[] {
		const activeFilters: string[] = [];

		if (route.query[FilterType.KEYWORD_WHAT] || route.params['kw-what']) activeFilters.push(FilterType.KEYWORD_WHAT);
		if (route.query[FilterType.KEYWORD_WHERE] || route.params['kw-where']) activeFilters.push(FilterType.KEYWORD_WHERE);
		if (route.query[FilterType.ORGANISATIONS]) activeFilters.push(FilterType.ORGANISATIONS);
		if (route.query[FilterType.DISCIPLINES] || route.params.discipline) activeFilters.push(FilterType.DISCIPLINES);
		if (route.query[FilterType.CONTINENT] || route.params.continent) activeFilters.push(FilterType.CONTINENT);
		if (route.query[FilterType.COUNTRY] || route.params.country) activeFilters.push(FilterType.COUNTRY);
		if (route.query[FilterType.AREA] || route.params.area) activeFilters.push(FilterType.AREA);
		if (route.query[FilterType.TUITION_FEE] || route.params.tuition_fee) activeFilters.push(FilterType.TUITION_FEE);
		if (route.query[FilterType.DURATION]) activeFilters.push(FilterType.DURATION);
		if (route.query[FilterType.ATTENDANCE]) activeFilters.push(FilterType.ATTENDANCE);
		if (route.query[FilterType.DELIVERY_METHOD]) activeFilters.push(FilterType.DELIVERY_METHOD);
		if (route.query[FilterType.DEGREE_TYPE] || route.params.degree_type) activeFilters.push(FilterType.DEGREE_TYPE);
		if (route.query[FilterType.EDUCATIONAL_FORM]) activeFilters.push(FilterType.EDUCATIONAL_FORM);
		if (route.query[FilterType.SPECIAL_PROGRAMMES]) activeFilters.push(FilterType.SPECIAL_PROGRAMMES);

		return activeFilters;
	}

	private storeNewUsageRecord(activeFilters: string[]): void {
		if (!this.isAmountOfFiltersNewUsageRecord(activeFilters)) {
			return;
		}

		DataStorage.store(this.storageLabel, JSON.stringify(activeFilters));
	}

	private isAmountOfFiltersNewUsageRecord(activeFilters: string[]): boolean {
		const currentAmountOfFilters = activeFilters.length;
		const existingRecord = DataStorage.retrieve(this.storageLabel) as string;

		if (!existingRecord) {
			return true;
		}

		return JSON.parse(existingRecord).length <= currentAmountOfFilters; //eslint-disable-line @typescript-eslint/no-unsafe-member-access
	}

	private announceFilterUpdate(): void {
		document.dispatchEvent(new CustomEvent('search_filters_updated'));
	}
}

export default new FilterUsageLogger();
